import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  connect() {
  }

  toggle(event) {
    event.preventDefault()

    const grid = event.currentTarget.getAttribute('data-grid-view-options-grid-option-value')
    const gridOptionsAvailable = ['list', 'grid']

    if (window._ && window._.includes && window._.includes(gridOptionsAvailable, grid)) {
      this.updateUrlWithGridOption(grid)
    } else if (gridOptionsAvailable.includes(grid)) {
      this.updateUrlWithGridOption(grid)
    }
  }

  updateUrlWithGridOption(grid) {
    const searchParams = new URLSearchParams(window.location.search)
    searchParams.set("grid_option", grid)
    window.location.search = searchParams.toString()
  }
}
